/* eslint-disable import/no-named-as-default-member */
import i18n from 'i18next';
import { initReactI18next, useTranslation as useTranslationImpl } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { buildLocaleForCountry, getInitialLanguage, defaultLanguage, defaultContur } from './utils';
import { STORES, CONTURS, LANGUAGES, defaultStore } from '../utils/config';

console.log('defaultLanguage >>>', { defaultLanguage, defaultStore, defaultContur });

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: {
      [LANGUAGES.ru]: { translation: buildLocaleForCountry(LANGUAGES.ru) },
      [LANGUAGES.kz]: { translation: buildLocaleForCountry(LANGUAGES.kz) },
      [LANGUAGES.ar]: { translation: buildLocaleForCountry(LANGUAGES.ar) },
      [LANGUAGES.en]: { translation: buildLocaleForCountry(LANGUAGES.en) },
    },
    lng: getInitialLanguage(),
    fallbackLng: defaultLanguage,
    supportedLngs: Object.values(LANGUAGES),
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'cookie'],
      lookupCookie: 'lang',
      lookupLocalStorage: 'lang',
      caches: ['localStorage', 'cookie'],
      checkWhitelist: true,
    },
  });

export const useTranslation = () => {
  return useTranslationImpl(undefined, {
    i18n,
  });
};

export const t = i18n.t;

// Экспортируем напрямую из импортированных значений
export { STORES as stores, LANGUAGES as languages, CONTURS as conturs, defaultLanguage, defaultStore, defaultContur };

export default i18n;
